import { Trans, useTranslation } from 'next-i18next';
export type TrialEndDiscountBulletKey = 'singleSeat' | 'maxMonths' | 'directPayment';

/** 모달 순서 (Figma 29139:2449) */
export const MODAL_BULLET_ORDER: TrialEndDiscountBulletKey[] = ['singleSeat', 'maxMonths', 'directPayment'];

/** 견적 페이지 안내 카드 순서 (Figma 29114:7245) */
export const QUOTE_BULLET_ORDER: TrialEndDiscountBulletKey[] = ['singleSeat', 'directPayment', 'maxMonths'];

/** Figma Dot(14px 컨테이너 안 5.25px 회색 점) */
function Dot() {
  return <span className="flex size-[14px] shrink-0 items-center justify-center" data-sentry-component="Dot" data-sentry-source-file="TrialEndDiscountBullets.tsx">
      <span className="size-[5.25px] rounded-full bg-[#9e9faf]" />
    </span>;
}

/** 체험 종료 할인 조건 3줄 (모달·견적 안내 카드 공용). */
export function TrialEndDiscountBullets({
  order,
  maxUserCount,
  maxMonthCount
}: {
  order: TrialEndDiscountBulletKey[];
  maxUserCount: number;
  maxMonthCount: number;
}) {
  const {
    t
  } = useTranslation(['common']);
  return <ul className="flex flex-col gap-3xs" data-sentry-component="TrialEndDiscountBullets" data-sentry-source-file="TrialEndDiscountBullets.tsx">
      {order.map(key => <li key={key} className="flex items-center gap-4xs opacity-90">
          <Dot />
          <p className="text-body-sm-medium text-alternative max-[560px]:text-body-md-medium">
            <Trans t={t} i18nKey={`common:trialEndDiscount.bullet.${key}`} values={{
          userCount: maxUserCount,
          monthCount: maxMonthCount
        }} components={{
          Strong: <strong className="text-body-sm-bold max-[560px]:text-body-md-bold" />
        }} />
          </p>
        </li>)}
    </ul>;
}